import React from 'react'
import type { Icon } from 'shared/utils'

const CircleWarningIcon = (props: Icon) => {
    const {
        color = 'black',
        size = 24,
        className = 'circle-warning',
        ...otherProps
    } = props
    return (
        <svg
            width={size}
            height={size}
            className={className}
            viewBox="0 0 24 24"
            {...otherProps}>
            <path
                d="M12 7a1 1 0 00-1 1v4a1 1 0 102 0V8a1 1 0 00-1-1zm.92 8.62a.76.76 0 00-.09-.18l-.12-.15a1 1 0 00-1.09-.21 1.15 1.15 0 00-.33.21 1 1 0 00-.21 1.09.9.9 0 00.54.54.94.94 0 00.76 0 .9.9 0 00.54-.54A1 1 0 0013 16a1.361 1.361 0 000-.2.64.64 0 00-.08-.18zM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0012 2zm0 18a8 8 0 110-16 8 8 0 010 16z"
                fill={color}
                fillRule="evenodd"
            />
        </svg>
    )
}

export { CircleWarningIcon }
